import api from './http';

// Opportunities
export const getOpportunities = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return api.get(`/opportunities${queryString ? `?${queryString}` : ''}`);
};
export const getOpportunity = (id) => api.get(`/opportunities/${id}`);
export const createOpportunity = (data) => api.post('/opportunities', data);
export const updateOpportunity = (id, data) => api.patch(`/opportunities/${id}`, data);
export const deleteOpportunity = (id) => api.delete(`/opportunities/${id}`);
export const exportOpportunities = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return api.get(`/opportunities/export${queryString ? `?${queryString}` : ''}`, { responseType: 'blob' });
};
export const getOpportunityHistory = (id) => api.get(`/opportunities/${id}/history`);
